import { DashboardTopPortal } from "shared";
import { ROLES_ENUM } from "enums";
import { CompaniesTabsType } from "../types";

interface InvestmentsTabsProps {
  tab: CompaniesTabsType["tab"];
  userRole?: string;
  handleChangeTab: (item: CompaniesTabsType["tab"]) => void;
}

const InvestmentsTabs = ({
  tab,
  userRole,
  handleChangeTab,
}: InvestmentsTabsProps) => {
  const isAdmin = userRole === ROLES_ENUM.ADMIN;
  const isUser = userRole === ROLES_ENUM.USER;
  return (
    <DashboardTopPortal>
      <div className="dashboard__tabs">
        {isUser ? (
          <span
            onClick={() => handleChangeTab("my")}
            className={`dashboard__tab ${
              tab === "my" ? "dashboard__tab--active" : ""
            } `}
          >
            Moje Aktywa
          </span>
        ) : null}
        <span
          onClick={() => handleChangeTab("reliance")}
          className={`dashboard__tab ${
            tab === "reliance" ? "dashboard__tab--active" : ""
          } `}
        >
          Aktywa Reliance
        </span>
        {isAdmin ? (
          <span
            onClick={() => handleChangeTab("other")}
            className={`dashboard__tab ${
              tab === "other" ? "dashboard__tab--active" : ""
            } `}
          >
            Pozostałe spółki
          </span>
        ) : null}
      </div>
    </DashboardTopPortal>
  );
};

export default InvestmentsTabs;
